/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TeamUserRoleType } from './TeamUserRoleType.js';
import {
    TeamUserRoleTypeFromJSON,
    TeamUserRoleTypeFromJSONTyped,
    TeamUserRoleTypeToJSON,
} from './TeamUserRoleType.js';

/**
 * 
 * @export
 * @interface TeamUserSummaryEntity
 */
export interface TeamUserSummaryEntity {
    /**
     * 
     * @type {number}
     * @memberof TeamUserSummaryEntity
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamUserSummaryEntity
     */
    teamId?: number;
    /**
     * 
     * @type {string}
     * @memberof TeamUserSummaryEntity
     */
    teamName?: string;
    /**
     * 
     * @type {TeamUserRoleType}
     * @memberof TeamUserSummaryEntity
     */
    role?: TeamUserRoleType;
}

/**
 * Check if a given object implements the TeamUserSummaryEntity interface.
 */
export function instanceOfTeamUserSummaryEntity(value: object): boolean {
    return true;
}

export function TeamUserSummaryEntityFromJSON(json: any): TeamUserSummaryEntity {
    return TeamUserSummaryEntityFromJSONTyped(json, false);
}

export function TeamUserSummaryEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamUserSummaryEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'role': json['role'] == null ? undefined : TeamUserRoleTypeFromJSON(json['role']),
    };
}

export function TeamUserSummaryEntityToJSON(value?: TeamUserSummaryEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'role': TeamUserRoleTypeToJSON(value['role']),
    };
}

